import { DateRangeFilter } from '@/components/_SiteWide/DateRangeFilter'
import { GraviButton, Horizontal } from '@gravitate-js/excalibrr'
import { Select } from 'antd'
import moment from 'moment/moment'

export function ControlBarActionButtons({
  setVisible,
  editScope,
  selectedStatus,
  setSelectedStatus,
  filters,
  setFilters,
  selectedDayRange,
  setSelectedDayRange,
  statusOptions,
}) {
  const getDatesFromStorage = () => {
    if (selectedDayRange) {
      return {
        From: moment().add(selectedDayRange.back, 'day').startOf('day'),
        To: moment().add(selectedDayRange.ahead, 'day').endOf('day'),
      }
    }
    return null
  }
  return (
    <Horizontal justifyContent='space-evenly' alignItems='center' gap={16}>
      <Select
        style={{ minWidth: '100px' }}
        value={selectedStatus || 'All'}
        onChange={(value) => setSelectedStatus(value)}
        options={statusOptions}
      />
      {editScope && <GraviButton theme2 buttonText='Create Request' onClick={() => setVisible(true)} />}

      <DateRangeFilter
        currentFilters={filters}
        setCurrentFilters={setFilters}
        getFromStorage={getDatesFromStorage}
        dayRangeStorage={selectedDayRange}
        setDayRangeStorage={setSelectedDayRange}
        fromKey='from'
        toKey='to'
      />
    </Horizontal>
  )
}
